import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@shared/components/button';
import { FieldErrorDirective, FormFieldComponent } from '@shared/components/form-field';
import { InputComponent } from '@shared/components/input';
import { ModalFooterDirective, ModalShellComponent } from '@shared/components/modal';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { suivreFormulaire } from '../../../../partage/forms/suivre-formulaire';
import { RedditionAnnulationService } from './reddition-annulation-service';
import { AnnulationForm } from './dialog-reddition-annulation.interface';
import { AnnulationDialogDataInput } from '../evenements.interface';
import { DevisePipe } from '../../../../partage/pipes/montant.pipe';

@Component({
  selector: 'app-dialog-reddition-annulation',
  imports: [
    DevisePipe,
    ModalShellComponent,
    ModalFooterDirective,
    ButtonComponent,
    FormFieldComponent,
    FieldErrorDirective,
    InputComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './dialog-reddition-annulation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './dialog-reddition-annulation.component.scss',
})
export class DialogRedditionAnnulationComponent implements OnInit {
  readonly dialogRef = inject(DialogRef);
  readonly data = inject<AnnulationDialogDataInput>(DIALOG_DATA);
  readonly annulationRedditionService = inject(RedditionAnnulationService);

  infosRedditionEnCours = this.annulationRedditionService.infosRedditionEnCours;

  annulationForm: FormGroup<AnnulationForm> = new FormGroup<AnnulationForm>({
    commentaire: new FormControl<string>(
      { value: '', disabled: false },
      {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(3)],
      },
    ),
  });

  // Lu par le gabarit : erreurs et validité notifiées à chaque validation
  protected readonly annulationFormSuivi = suivreFormulaire(this.annulationForm);

  ngOnInit(): void {
    this.annulationRedditionService.setEvenement(this.data.evenement);
  }

  submit(): void {
    this.dialogRef.close({
      idReddition: this.infosRedditionEnCours()!.idReddition,
      commentaire: this.annulationForm.value.commentaire,
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
